/* ==========================================================================
   Satjeevan — Testimonials Section JS (sj-testimonials.js)
   Continuous right-to-left auto-scroll drift slider. Pauses on hover.
   ========================================================================== */

(function() {
  'use strict';

  /* ==========================================================================
     ★ CONFIGURATION — change 'on' to 'off' to disable auto-scroll entirely
     ========================================================================== */
  var AUTO_SCROLL = 'on'; // 'on' | 'off'
  /* ========================================================================== */

  var SCROLL_DELAY_MS = 3000; // ms to wait before auto-scroll begins
  var GAP = 22;
  var SPEED = 22; // px per second

  function initTestimonials() {
    /** @type {NodeListOf<HTMLElement>} */
    var viewports = document.querySelectorAll('.sj-testi-viewport');
    
    viewports.forEach(function(viewport) {
      // Prevent double initialization
      if (viewport.hasAttribute('data-sj-init')) return;
      viewport.setAttribute('data-sj-init', '1');

      var track = /** @type {HTMLElement} */ (viewport.querySelector('.sj-testi-track'));
      if (!track) return;

      /** @type {HTMLElement[]} */
      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;

      // Handle prefers-reduced-motion
      var mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mediaQuery.matches) {
        // Accessibility: CSS handles horizontal scroll, don't run JS animation
        return;
      }

      if (AUTO_SCROLL !== 'on') return;

      var cardWidth = 0, setWidth = 0;
      var trackX = 0;
      var scrollingPaused = false;
      var delayActive = true;
      var userScrolling = false;
      /** @type {number | null} */
      var lastTime = null;
      /** @type {number | null} */
      var rafId = null;
      /** @type {number | null} */
      var scrollResumeTimer = null;

      function measure() {
        if (!cards[0]) return;
        cardWidth = cards[0].getBoundingClientRect().width;
        // The track contains two identical sets back-to-back for seamless looping.
        // We find the width of half the cards.
        var uniqueCount = Math.round(cards.length / 2); 
        setWidth = uniqueCount * (cardWidth + GAP);
      }

      /**
       * @param {number} t
       */
      function frame(t) {
        if (lastTime === null) lastTime = t;
        var dt = Math.min((t - lastTime) / 1000, 0.05);
        lastTime = t;

        if (!scrollingPaused && !delayActive) {
          trackX -= SPEED * dt;
          if (trackX <= -setWidth) trackX += setWidth;
        }
        track.style.transform = 'translateX(' + trackX + 'px)';

        // Idle instead of endlessly rescheduling: while paused (hover/focus/
        // drag), still in the initial delay, or mid-scroll-gesture, nothing
        // changes visually from tick to tick, so stop the rAF chain rather
        // than keep waking the main thread up ~60x/second for no reason — a
        // running rAF loop competes with the browser's own scroll/compositing
        // work on every single frame, which is exactly what shows up as
        // stutter on mobile. ensureRunning() restarts the chain the moment
        // any of those conditions clears.
        if (scrollingPaused || delayActive || userScrolling) {
          rafId = null;
          return;
        }
        rafId = requestAnimationFrame(frame);
      }

      function ensureRunning() {
        if (rafId !== null || scrollingPaused || delayActive || userScrolling) return;
        lastTime = null;
        rafId = requestAnimationFrame(frame);
      }

      function onWindowScroll() {
        userScrolling = true;
        if (scrollResumeTimer) clearTimeout(scrollResumeTimer);
        scrollResumeTimer = setTimeout(function () {
          scrollResumeTimer = null;
          userScrolling = false;
          ensureRunning();
        }, 200);
      }

      measure();
      window.addEventListener('resize', measure);
      window.addEventListener('scroll', onWindowScroll, { passive: true });

      rafId = requestAnimationFrame(frame);

      setTimeout(function () {
        delayActive = false;
        ensureRunning();
      }, SCROLL_DELAY_MS);

      // Pause on hover
      viewport.addEventListener('mouseenter', function() { scrollingPaused = true; });
      viewport.addEventListener('mouseleave', function() { scrollingPaused = false; ensureRunning(); });

      // Accessibility: pause on focus
      viewport.addEventListener('focusin', function() { scrollingPaused = true; });
      viewport.addEventListener('focusout', function() { scrollingPaused = false; ensureRunning(); });

      // Manual drag and swipe support
      var isDragging = false;
      var startX = 0;
      var touchStartTrackX = 0;
      /** @type {number | null} */
      var snapRafId = null;

      // Settles a touch swipe on exactly one full card (forward or back)
      // instead of leaving the track wherever the raw finger movement
      // happened to stop — a short swipe used to only move the track by
      // however far the thumb travelled (often less than a full card).
      /**
       * @param {number} target
       */
      function snapTrackToTouch(target) {
        if (snapRafId !== null) {
          cancelAnimationFrame(snapRafId);
          snapRafId = null;
        }
        var start = trackX;
        var distance = target - start;
        var duration = 260;
        /** @type {number | null} */
        var startTime = null;

        /**
         * @param {number} now
         */
        function step(now) {
          if (startTime === null) startTime = now;
          var progress = Math.min((now - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          trackX = start + distance * eased;
          track.style.transform = 'translateX(' + trackX + 'px)';

          if (progress < 1) {
            snapRafId = requestAnimationFrame(step);
          } else {
            snapRafId = null;
            scrollingPaused = false;
            ensureRunning();
          }
        }
        snapRafId = requestAnimationFrame(step);
      }

      // Mouse drag
      viewport.addEventListener('mousedown', function(e) {
        var me = /** @type {MouseEvent} */ (e);
        isDragging = true;
        startX = me.pageX;
        scrollingPaused = true;
      });
      window.addEventListener('mousemove', function(e) {
        var me = /** @type {MouseEvent} */ (e);
        if (!isDragging) return;
        var dx = me.pageX - startX;
        trackX += dx;
        startX = me.pageX;
        if (trackX <= -setWidth) trackX += setWidth;
        if (trackX > 0) trackX -= setWidth;
        track.style.transform = 'translateX(' + trackX + 'px)';
      });
      window.addEventListener('mouseup', function() {
        isDragging = false;
        // scrollingPaused = false handled by mouseleave if they leave, 
        // if they stay, hover state applies so it should remain paused.
      });

      // Touch swipe
      viewport.addEventListener('touchstart', function(e) {
        var te = /** @type {TouchEvent} */ (e);
        if (!te.touches || !te.touches[0]) return;
        isDragging = true;
        startX = te.touches[0].pageX;
        touchStartTrackX = trackX;
        scrollingPaused = true;
      }, {passive: true});
      window.addEventListener('touchmove', function(e) {
        var te = /** @type {TouchEvent} */ (e);
        if (!isDragging || !te.touches || !te.touches[0]) return;
        var dx = te.touches[0].pageX - startX;
        trackX += dx;
        startX = te.touches[0].pageX;
        if (trackX <= -setWidth) trackX += setWidth;
        if (trackX > 0) trackX -= setWidth;
        if (track) {
          track.style.transform = 'translateX(' + trackX + 'px)';
        }
      }, {passive: true});
      window.addEventListener('touchend', function() {
        isDragging = false;

        var pitch = cardWidth + GAP;
        var dragged = trackX - touchStartTrackX;
        var target = touchStartTrackX;
        if (pitch > 0 && Math.abs(dragged) > 10) {
          target = touchStartTrackX + (dragged < 0 ? -pitch : pitch);
        }
        if (target <= -setWidth) target += setWidth;
        if (target > 0) target -= setWidth;

        snapTrackToTouch(target);
      });

      // Wheel / Trackpad scroll
      viewport.addEventListener('wheel', function(e) {
        var we = /** @type {WheelEvent} */ (e);
        if (Math.abs(we.deltaX) > Math.abs(we.deltaY)) {
          we.preventDefault();
          trackX -= we.deltaX;
          if (trackX <= -setWidth) trackX += setWidth;
          if (trackX > 0) trackX -= setWidth;
          track.style.transform = 'translateX(' + trackX + 'px)';
        }
      }, { passive: false });
    });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initTestimonials();
      initVideoTestimonials();
    });
  } else {
    initTestimonials();
    initVideoTestimonials();
  }

  // Shopify Theme Editor live-reload support
  document.addEventListener('shopify:section:load', function (event) {
    var ev = /** @type {CustomEvent} */ (event);
    var target = /** @type {HTMLElement} */ (ev.target);
    if (target && target.querySelector('.sj-testi-viewport')) {
      initTestimonials();
    }
    if (target && target.querySelector('.sj-testi-video-wrap')) {
      initVideoTestimonials();
    }
  });
  
  document.addEventListener('shopify:block:select', function() {
    initTestimonials();
    initVideoTestimonials();
  });

  function initVideoTestimonials() {
    /** @type {NodeListOf<HTMLElement>} */
    var videoWraps = document.querySelectorAll('.sj-testi-video-wrap');
    videoWraps.forEach(function(wrap) {
      if (wrap.hasAttribute('data-sj-vid-init')) return;
      wrap.setAttribute('data-sj-vid-init', '1');

      /** @type {HTMLVideoElement | null} */
      var video = wrap.querySelector('video');
      /** @type {HTMLElement | null} */
      var btn = wrap.querySelector('.sj-testi-video-btn');
      if (!video || !btn) return;

      /** @type {HTMLElement | null} */
      var iconPlay = btn.querySelector('.sj-icon-play');
      /** @type {HTMLElement | null} */
      var iconPause = btn.querySelector('.sj-icon-pause');

      function updateBtnState() {
        if (video && video.paused) {
          if (iconPlay) iconPlay.style.display = 'block';
          if (iconPause) iconPause.style.display = 'none';
        } else {
          if (iconPlay) iconPlay.style.display = 'none';
          if (iconPause) iconPause.style.display = 'block';
        }
      }

      updateBtnState();

      if (video) {
        video.addEventListener('play', updateBtnState);
        video.addEventListener('pause', updateBtnState);
      }
      
      // Make the wrap itself toggle play/pause on click (if not dragging)
      var isClickDrag = false;
      wrap.addEventListener('mousedown', function() { isClickDrag = false; });
      wrap.addEventListener('mousemove', function() { isClickDrag = true; });
      wrap.addEventListener('mouseup', function(e) {
        if (!isClickDrag) {
          e.preventDefault();
          if (video && video.paused) {
            video.play();
          } else if (video) {
            video.pause();
          }
        }
      });
    });
  }

})();
